import { FC, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import SelectComponent, { defaultSelectStyles } from 'components/Inputs/SelectComponent';
import { createdByOptions, NAME } from './constants';
import { CreatedBySelectTransFields } from './types';
import { createdBySelectTranslations } from './translations';

export const CreatedBySelect: FC = () => {
  const { setValue, getValues } = useFormContext();

  const { t } = useMyTranslations<CreatedBySelectTransFields>([createdBySelectTranslations.name]);

  useEffect(() => {
    const val = getValues(NAME);
    setValue(NAME, { id: val.id, name: t(val.name) });
  }, []);

  return (
    <SelectComponent
      name={NAME}
      options={createdByOptions.map((item) => ({ id: item, name: t(item) }))}
      styleProps={defaultSelectStyles}
      optionValue='id'
      optionLabel='name'
      isClearable={false}
    />
  );
};
